import { LinesContainer, LogosContainer, Container, ImageContainer } from './Lines.style'
import DrLogo from '../../assets/Lines/dr-r-by.png'
import TegorLogo from '../../assets/Lines/tegor-by.png'
import SymbioLogo from '../../assets/Lines/symbio-by.png'
import KvpLogo from '../../assets/Lines/kvp-by.png'
import HelixorLogo from '../../assets/Lines/helixor-by.png'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const logos = [DrLogo, TegorLogo, SymbioLogo, HelixorLogo, KvpLogo]

const Lines = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    autoplay: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1100, // Tablets
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 550, // Phones
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <LinesContainer>
      <Container>
        <h1>Nuestras <span>Líneas</span></h1>
        <Slider {...settings}>
          {logos.map((logo, index) => (
              <ImageContainer>
                <img key={index} src={logo} alt={`Logo ${index}`} />
              </ImageContainer>
          ))}
        </Slider>
      </Container>
    </LinesContainer>
  )
}

export default Lines
